import * as Yup from "yup";
import {
  REQUIRED_FIELD,
  REQUIRED_NUMBER_FIELD,
  REQUIRED_NUMBER_WITH_NIL_FIELD,
  REQUIRED_NUMBER_WITH_ZERO_FIELD,
  REQUIRED_NUMBER_WITH_ZERO_NIL_FIELD,
} from "../../common/validation";
const createDependentField = (dependencyKey, message = false) =>
  Yup.lazy((value, { parent }) => {
    const validationMessge = !message
      ? `Cannot exceed Scheduled Count`
      : `Cannot exceed Present Count`;
    return (
      Yup.number()
        .nullable()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value
        )
        // .required("This field is required!")
        .typeError("Invalid value")
        .min(0, "Value cannot be negative")
        .max(parent[dependencyKey], validationMessge)
    );
  });
const createConditionalField = (dependencyKey, triggerValue) =>
  Yup.string()
    .nullable()
    .when(dependencyKey, {
      is: (value) => value === triggerValue, // Trigger validation when the dependency field matches the condition
      then: () => REQUIRED_FIELD,
      otherwise: () => Yup.string().notRequired(), // Optional when the condition is not met
    });
const createConditionalFieldOnlyPositiveNumbers = (dependencyKey, triggerValue) =>
  Yup.string()
    .nullable()
    .when(dependencyKey, {
      is: (value) => value === triggerValue, // Trigger validation when the dependency field matches the condition
      then: () => REQUIRED_NUMBER_FIELD,
      otherwise: () => Yup.string().notRequired(), // Optional when the condition is not met
    });
const createConditionalFieldOnlyNumbers = (dependencyKey, triggerValue) =>
  Yup.string()
    .nullable()
    .when(dependencyKey, {
      is: (value) => value === triggerValue, // Trigger validation when the dependency field matches the condition
      then: () => REQUIRED_NUMBER_WITH_ZERO_FIELD,
      otherwise: () => Yup.string().notRequired(), // Optional when the condition is not met
    });
const createAdhaarDependentValidation = (
  dependentKey, // Field to depend on (e.g., questions_3)
  otherFieldKey, // Sibling field to include in the validation
  errorMessage = "(Registered + Bypass) cannot exceed Present Count" // Error message for exceeding dependentKey
) =>
  Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .typeError("Invalid value!")
    .min(0, "Value cannot be negative!")
    .test(
      "dependent-validation",
      errorMessage, // Use the specific error message for this validation
      function (value) {
        const {
          [dependentKey]: dependentValue = 0,
          [otherFieldKey]: otherValue = 0,
        } = this.parent;
        return (
          !dependentValue || (value || 0) + (otherValue || 0) <= dependentValue
        );
      }
    );
const shiftValidation = {
  //shift-1
  // questions_2: REQUIRED_NUMBER_FIELD,
  questions_3: createDependentField("questions_2"),

  questions_6: createDependentField("questions_3", true),
  // questions_7: REQUIRED_NUMBER_WITH_ZERO_FIELD,
  questions_8: createAdhaarDependentValidation("questions_3", "questions_9"),
  questions_9: createAdhaarDependentValidation("questions_3", "questions_8"),

  //shift-2
  // questions_11: REQUIRED_NUMBER_FIELD,
  questions_12: createDependentField("questions_11"),

  questions_15: createDependentField("questions_12", true),
  // questions_16: REQUIRED_NUMBER_FIELD,
  questions_17: createAdhaarDependentValidation("questions_12", "questions_18"),
  questions_18: createAdhaarDependentValidation("questions_12", "questions_17"),

  //shift-3
  // questions_20: REQUIRED_NUMBER_FIELD,
  questions_21: createDependentField("questions_20"),

  questions_24: createDependentField("questions_21", true),
  // questions_25: REQUIRED_NUMBER_FIELD,
  questions_26: createAdhaarDependentValidation("questions_21", "questions_27"),
  questions_27: createAdhaarDependentValidation("questions_21", "questions_26"),
};
export const noValidationSchema = Yup.object().shape({ ...shiftValidation });
export const reportSchema = Yup.object().shape({
  ...shiftValidation,

  questions_28: REQUIRED_FIELD,
  ans_28: createConditionalField("questions_28", "No"),

  questions_29: REQUIRED_FIELD,
  questions_30: createConditionalFieldOnlyPositiveNumbers(
    "questions_29",
    "Not Conducted Smoothly"
  ),
  questions_31: createConditionalField(
    "questions_29",
    "Not Conducted Smoothly"
  ),

  questions_32: REQUIRED_FIELD,
  questions_33: createConditionalFieldOnlyPositiveNumbers("questions_32", "Yes"),
  questions_34: createConditionalFieldOnlyPositiveNumbers("questions_32", "Yes"),
  questions_35: createConditionalField("questions_32", "Yes"),

  questions_36: REQUIRED_FIELD,

  questions_38: REQUIRED_FIELD,
  ans_38: createConditionalField("questions_38", "Absent"),
  questions_39: REQUIRED_FIELD,
  ans_39: createConditionalField("questions_39", "Absent"),
  questions_40: REQUIRED_FIELD,
  ans_40: createConditionalField("questions_40", "Absent"),
  questions_41: REQUIRED_FIELD,
  ans_41: createConditionalField("questions_41", "Absent"),
  questions_42: REQUIRED_FIELD,
  ans_42: createConditionalField("questions_42", "Absent"),

  questions_43: REQUIRED_FIELD,

  questions_44: REQUIRED_FIELD,

  questions_46: REQUIRED_FIELD,
  // ans_46: createConditionalField("questions_46", "Absent"),
  questions_47: REQUIRED_FIELD,
  ans_47: createConditionalField("questions_47", "Absent"),
  questions_48: REQUIRED_FIELD,
  ans_48: createConditionalField("questions_48", "Absent"),
  questions_49: REQUIRED_FIELD,
  ans_49: createConditionalField("questions_49", "Absent"),
  questions_50: REQUIRED_FIELD,
  ans_50: createConditionalField("questions_50", "Absent"),
  questions_51: REQUIRED_FIELD,
  ans_51: createConditionalField("questions_51", "Absent"),

  questions_52: REQUIRED_FIELD,

  questions_53: REQUIRED_FIELD,
  questions_54: createConditionalField("questions_53", "Yes"),
  questions_55: createConditionalFieldOnlyNumbers("questions_53", "Yes"),
  questions_56: createConditionalField("questions_53", "Yes"),

  questions_58: REQUIRED_NUMBER_WITH_NIL_FIELD,
  questions_59: REQUIRED_NUMBER_WITH_NIL_FIELD,
  questions_60: REQUIRED_NUMBER_WITH_NIL_FIELD,
  questions_61: REQUIRED_NUMBER_WITH_NIL_FIELD,
  questions_62: REQUIRED_NUMBER_WITH_NIL_FIELD,

  questions_63: REQUIRED_FIELD,
  ans_63: createConditionalField("questions_63","Yes"),

  questions_64: REQUIRED_FIELD,
  ans_64: createConditionalField("questions_64","Yes"),

  // questions_65: REQUIRED_FIELD,

  // questions_66: REQUIRED_FIELD,

  // questions_67: REQUIRED_FIELD,

  questions_68: REQUIRED_FIELD,

  questions_69: REQUIRED_FIELD,
});
